import Footer from "../Common/Footer";
import Header from "../Common/Header";

import React, { useEffect } from "react";

import Carousel from "react-multi-carousel";
import "react-multi-carousel/lib/styles.css";
const responsive = {
  superLargeDesktop: {
    // the naming can be any, depends on you.
    breakpoint: { max: 4000, min: 3000 },
    items: 5
  },
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 4
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 2
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1
  }
};


function Products() {
  
    useEffect(() => {
      window.scrollTo(0, 0);
    }, []);
    
  return (
  
  <>
  <Header />
  <div
    className="breadcumb-wrapper"
    style={{backgroundImage:"url(" + "assets/img/bg/breadcumb-bg.jpg" + ")", backgroundRepeat:'no-repeat', backgroundPosition:'center center', backgroundSize:'cover'}}
  >
    <div className="container z-index-common">
      <div className="breadcumb-content">
        <h1 className="breadcumb-title">Products</h1>
       
      </div>
    </div>
  </div>
  <section className="space-top space-extra-bottom">
    <div className="container">
    
      <div className="row gy-30">

        
      <div className="col-lg-12">
          <h4>Milk</h4>
        <Carousel responsive={responsive}>

          
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/milk/25.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Tea Milk-450 ML
              </h3>
              <span className="price">₹22</span>
            </div>
          </div>
          </div>

                
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
             <img src="assets/img/products/milk/27.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Tea Milk-150 ML
              </h3>
              <span className="price">₹10</span>
            </div>
          </div>
          </div>

          
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
             <img src="assets/img/products/milk/29.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
              Cow Milk-350 ML
              </h3>
              <span className="price">₹20</span>
            </div>
          </div>
          </div>

    
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
           <img src="assets/img/products/milk/30.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
              Tonned Milk-500 ML
              </h3>
              <span className="price">₹29</span>
            </div>
          </div>
          </div>


          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
             <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
            SKM-180 ML</h3>
              <span className="price">₹10</span>
            </div>
          </div>
          </div>

          

          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/milk/31.jpg" alt="Icon" />  
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
            SKM-450 ML    </h3>
              <span className="price">₹25</span>
            </div>
          </div>
          </div>


          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
              <img src="assets/img/products/milk/32.jpg" alt="Icon" />  
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
            FAMILY MILK-450 ML     </h3>
              <span className="price">₹33</span>
            </div>
          </div>
          </div>


          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/milk/33.jpg" alt="Icon" />  
              
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             DTM-500 ML   </h3>
              <span className="price">₹22</span>
            </div>
          </div>
          </div>


          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
           DTM 200 Ml  </h3>
              <span className="price">₹10</span>
            </div>
          </div>
          </div>
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
             <img src="assets/img/products/milk/34.jpg" alt="Icon" />  
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
            Fcm-480 ML </h3>
              <span className="price">₹35</span>
            </div>
          </div>
          </div>


          
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
             <img src="assets/img/products/milk/35.png" alt="Icon" />  
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
            Fcm-950 ML</h3>
              <span className="price">₹70</span>
            </div>
          </div>
          </div>


          
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
             <img src="assets/img/products/dummy.jpg" alt="Icon" />  
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
          FCM-6 Ltr </h3>
              <span className="price">₹426</span>
            </div>
          </div>
          </div>
          
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
              <img src="assets/img/products/dummy.jpg" alt="Icon" />  
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
           Tea Gold-500 ML </h3>
              <span className="price">₹36</span>
            </div>
          </div>
          </div>

          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
              <img src="assets/img/products/dummy.jpg" alt="Icon" />  
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
          Tea Gold-160 ML </h3>
              <span className="price">₹10</span>
            </div>
          </div>
          </div>


          

          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
              <img src="assets/img/products/dummy.jpg" alt="Icon" />  
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
          Cream Loose</h3>
              <span className="price">₹300</span>
            </div>
          </div>
          </div>


    
  
          </Carousel>
        </div>


        <div className="col-lg-12">
          <h4>Dahi</h4>
        <Carousel responsive={responsive}>

          
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />  

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Curd Cup 80 Gm
              </h3>
              <span className="price">₹7.5</span>
            </div>
          </div>
          </div>


          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
             <img src="assets/img/products/dummy.jpg" alt="Icon" />  
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
                  Eco Curd 5Kg
              </h3>
              <span className="price">₹180</span>
            </div>
          </div>
          </div>

          

          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
             <img src="assets/img/products/dummy.jpg" alt="Icon" />  
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
              FIT Curd -5Kg
              </h3>
              <span className="price">₹350</span>
            </div>
          </div>
          </div>
      
      
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
             <img src="assets/img/products/dummy.jpg" alt="Icon" />  

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Fit Curd 15 Kg
              </h3>
              <span className="price">₹1020</span>
            </div>
          </div>
          </div>


          
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dahi/20.jpg" alt="Icon" />  
              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
            Fresh Curd-500 Gm
              </h3>
              <span className="price">₹45</span>
            </div>
          </div>
          </div>
          
          
          
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dahi/22.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Lite Curd-150 Gm
              </h3>
              <span className="price">₹15</span>
            </div>
          </div>
          </div>

            
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Lite Curd-15 Kg          
               </h3>
              <span className="price">₹1170</span>
            </div>
          </div>
          </div>

          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dahi/23.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Lite Curd-5kg       
               </h3>
              <span className="price">₹400</span>
            </div>
          </div>
          </div>



          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dahi/24.png" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
              Curd Cup-180 Gm (Pcs)
               </h3>
              <span className="price">₹20</span>
            </div>
          </div>
          </div>

        
  
          </Carousel>
        </div>
      

        <div className="col-lg-12">
          <h4>Buttermilk</h4>
        <Carousel responsive={responsive}>

          
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Mathha
              </h3>
              <span className="price">₹30</span>
            </div>
          </div>
          </div>


          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
            Plain Chhach-400 ML (Bottle)
              </h3>
              <span className="price">₹25</span>
            </div>
          </div>
          </div>

          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
              Masala Chhach-400 ML (Bottle)
              </h3>
              <span className="price">₹25</span>
            </div>
          </div>
          </div>

          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
            Plain Chhach-300 ML
              </h3>
              <span className="price">₹14</span>
            </div>
          </div>
          </div>

           <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/chaanch/19.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
            Masala Chhach-300 ML
              </h3>
              <span className="price">₹14</span>
            </div>
          </div>
          </div>
      
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Plain Chhach-400 ML(Packet)
              </h3>
              <span className="price">₹15</span>
            </div>
          </div>
          </div>


  
          </Carousel>
        </div>
      

      
        <div className="col-lg-12">
          <h4>Paneer</h4>
        <Carousel responsive={responsive}>

          
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Paneer Loose
              </h3>
              <span className="price">₹350</span>
            </div>
          </div>
          </div>



          
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
           Paneer Packed 1 Kg
              </h3>
              <span className="price">₹410</span>
            </div>
          </div>
          </div>

          
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
              Paneer Packed 200 Gm
              </h3>
              <span className="price">₹85</span>
            </div>
          </div>
          </div>



  
          </Carousel>
        </div>


           
        <div className="col-lg-12">
          <h4>Tanker</h4>
        <Carousel responsive={responsive}>

          
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Cow Milk
              </h3>
              <span className="price">₹60</span>
            </div>
          </div>
          </div>

                
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Mixed Milk
              </h3>
              <span className="price">₹60</span>
            </div>
          </div>
          </div>

          
          <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             Milk
              </h3>
              <span className="price">₹60</span>
            </div>
          </div>
          </div>

  
          </Carousel>
        </div>
      
     
        <div className="col-lg-12">
          <h4>Butter</h4>
        <Carousel responsive={responsive}>

          
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
              Yellow Butter-Cow
              </h3>
              <span className="price">₹500</span>
            </div>
          </div>
          </div>

                
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
             White Butter
              </h3>
              <span className="price">₹500</span>
            </div>
          </div>
          </div>

          
        
  
          </Carousel>
        </div>





        <div className="col-lg-12">
          <h4>Sweets</h4>
        <Carousel responsive={responsive}>

          
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
              Rasbhari
              </h3>
              <span className="price">₹400</span>
            </div>
          </div>
          </div>

                
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
           Rasmalai (Pcs)
              </h3>
              <span className="price">₹45</span>
            </div>
          </div>
          </div>

                    
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
           Spunch Rasgulla (Pcs.)
              </h3>
              <span className="price">₹45</span>
            </div>
          </div>
          </div>

                    
        <div>  
             <div className="ot-product product-grid">
            <div className="product-img">
            <img src="assets/img/products/dummy.jpg" alt="Icon" />

              
            </div>
            <div className="product-content">
             
              <h3 className="product-title">
          Khoa-Loose
              </h3>
              <span className="price">₹350</span>
            </div>
          </div>
          </div>

          
        
  
          </Carousel>
        </div>


      </div>
    
    </div>
  </section>
  
  <Footer />
</>

  );
}

export default Products;
